export default {
  translation: {
    "Access denied": "Access denied",
    Active: "Active",
    "At least one role required": "At least one role is required",
    "Attention!": "Attention!",
    "Authorization required": "Authorization required",
    Cancel: "Cancel",
    Class: "Class",
    "Click or drag the file/s to the area to upload":
      "Click or drag the file/s to the area to upload. Downloading from the clipboard is possible.",
    Close: "Close",
    Continue: "Continue",
    "Continue with data loss": "Continue with data loss?",
    "Created at": "Created at",
    "Created by": "Created by",
    "Created successfully [entity]": "{{entity}} created successfully",
    Create: "Create",
    DateFormat: "MM/DD/YYYY",
    DateTimeFormat: "MM/DD/YYYY HH:mm",
    Deactivated: "Deactivated",
    Delete: "Delete",
    "Delete [entity]": "Delete {{entity}}",
    "Deleted successfully [entity]": "{{entity}} deleted successfully",
    Description: "Description",
    "Display ID": "Display ID",
    "Edit [entity]": "Edit {{entity}}",
    Email: "Email",
    "Error loading [entity]": "Error loading {{entity}}",
    "Error saving [entity]": "Error saving {{entity}}",
    "Error when accessing the server": "Error when accessing the server",
    "Field required": "Field is required",
    "File modification": "File modification",
    Finish: "Finish",
    "First name": "First name",
    Filter: "Filter",
    "Format: value": "Format: {{value}}",
    "Incorrect format of received data": "Incorrect format of received data",
    "Image modification": "Image modification",
    "Invalid data format:": "Invalid data format for {{file}}",
    "Invalid email": "Invalid email",
    "Invalid page URL": "Invalid page URL",
    "Last name": "Last name",
    Login: "Login",
    "Sign In": "Sign In",
    Logout: "Logout",
    Management: "Management",
    "Maximum number: count": "Maximum number: {{count}}",
    "Metadata editor": "Metadata editor",
    "Middle name": "Middle name",
    "Min value required": "Value must be at least {{value}}",
    Name: "Name",
    "Navigation blocked": "Navigation blocked",
    "New [entity]": "New {{entity}}",
    No: "No",
    Password: "Password",
    "Please enter [field]": "Please enter {{field}}",
    Repeat: "Repeat",
    Reload: "Reload",
    Role: "Role",
    Roles: "Roles",
    Save: "Save",
    "Server error": "Server error",
    Status: "Status",
    TimeFormat: "HH:mm:ss",
    Title: "Title",
    "Unsaved changes warning": "Form has unsaved changes.",
    "Updated at": "Updated at",
    "Updated by": "Updated by",
    "Updated successfully [entity]": "{{entity}} updated successfully",
    Upload: "Upload",
    User: "User",
    Users: "Users",
    UUID: "UUID",
    Yes: "Yes",
  },
};
